import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { OfferCards } from './components/OfferCards';
import { KitModules } from './components/KitModules';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecentPurchases } from './components/RecentPurchases';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '794641966815768');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen font-sans selection:bg-mint/30 relative" data-id="element-0">
      {/* Central Emerald Glow */}
      <div className="fixed inset-0 pointer-events-none z-0 flex items-center justify-center overflow-hidden" data-id="element-1">
        <div className="w-[800px] h-[800px] bg-mint/10 rounded-full blur-[120px] opacity-60" data-id="element-2" />
      </div>

      <div className="relative z-10" data-id="element-3">
        <Hero data-id="element-4" />
        <SocialProof data-id="element-5" />
        <PainPoints data-id="element-6" />
        <Tomos data-id="element-7" />
        <Bonuses data-id="element-8" />
        <OfferCards data-id="element-9" />
        <KitModules data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
        <Footer data-id="element-15" />
        <RecentPurchases data-id="element-16" />
      </div>
    </div>;
}